import _ from 'lodash';

import { requestWithToken } from '../../utilities/request';

const fieldPath = '/api/private/fields';

/**
 * 現場紐付協力会社情報取得API
 * @param {number} fieldId 現場ID
 * @param {object} param
 * */
const fetchFieldTreeCompanyBranchList = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: fieldPath.concat(`/${fieldId}/field_trees/tree_company_branches`),
    params: param,
  });
};

/**
 * 協力会社一覧取得
 * @param {object} param 検索条件
 * */
const fetchPartnerCompanyList = param => {
  return requestWithToken({
    method: 'GET',
    url: '/api/private/company_branches/tree_company_list',
    params: param,
  });
};

const create = (fieldId, param) => {
  return requestWithToken({
    method: 'POST',
    url: fieldPath.concat(`/${fieldId}/field_trees/`),
    data: param,
  });
};

const createWithCompany = (fieldId, param) => {
  return requestWithToken({
    method: 'POST',
    url: fieldPath.concat(`/${fieldId}/field_trees/create_with_company`),
    data: createFormData(param),
  });
};

/**
 * データパラメータ生成
 * @param param {object}
 * @return fd {object}
 */
function createFormData(param) {
  var fd = new FormData();
  _.each(param, (value, index) => {
    if (value && value.type == 'file') {
      fd.append('icon_image', value.files[0]);
    } else {
      if (index === 'password_reset_notice_user') {
        // console.log('value', value);
        fd.append(index, value == undefined ? '' : value);
      } else if (Object.prototype.toString.call(value) === '[object Object]') {
        // eslint-disable-next-line no-unused-vars
        let obj = {};
        _.each(value, (val, col) => {
          fd.append(`${index}[${col}]`, val == undefined ? '' : val);
        });
      } else {
        fd.append(index, value == undefined ? '' : value);
      }
    }
  });

  return fd;
}

/**
 * 施工体系のAPI群
 * */
export const FieldTreesApi = {
  create,
  createWithCompany,
  fetchFieldTreeCompanyBranchList,
  fetchPartnerCompanyList,
};

export default FieldTreesApi;



// WEBPACK FOOTER //
// ./src/services/fieldTrees/FieldTreesApi.js